// extracted by css-extract-rspack-plugin
export default {"container":"src-app-components-forms-LabelBox-LabelBox-module__container-M7FH4z","title":"src-app-components-forms-LabelBox-LabelBox-module__title-tkD6HB","need":"src-app-components-forms-LabelBox-LabelBox-module__need-F9tQHU","footer":"src-app-components-forms-LabelBox-LabelBox-module__footer-bhhEbs","textField":"src-app-components-forms-LabelBox-LabelBox-module__textField-lgurrI"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-app-components-forms-LabelBox-LabelBox-module__container-M7FH4z\",\"title\":\"src-app-components-forms-LabelBox-LabelBox-module__title-tkD6HB\",\"need\":\"src-app-components-forms-LabelBox-LabelBox-module__need-F9tQHU\",\"footer\":\"src-app-components-forms-LabelBox-LabelBox-module__footer-bhhEbs\",\"textField\":\"src-app-components-forms-LabelBox-LabelBox-module__textField-lgurrI\"}";
        // 1789362522834
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  